/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["th{cursor:pointer}.no-pointer{cursor:default}.menu{margin-bottom:5px}td button{padding-top:5px;padding-bottom:5px;padding-left:11px}.projects td{padding-left:.5em}td.button{cursor:pointer}td.button span.icon{padding-bottom:1px;padding-left:2px}button.go-back span.icon{margin-top:-1px}.manage-projects table{width:calc(100% - 10px);max-width:990px;margin:auto auto 15px}"];
export { styles as styles };
